/**
 * Hook customizado para autenticação
 */

import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '@services';
import { LoginVendedorRequest, ROUTES } from '@types';

interface UseAuthReturn {
  isLoading: boolean;
  error: string | null;
  login: (credentials: LoginVendedorRequest) => Promise<void>;
  logout: () => void;
  clearError: () => void;
}

export const useAuth = (): UseAuthReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const login = useCallback(
    async (credentials: LoginVendedorRequest) => {
      setIsLoading(true);
      setError(null);

      try {
        await authService.login(credentials);
        navigate(ROUTES.HOME);
      } catch (err: any) {
        const errorMessage = err.message || 'Erro ao fazer login';
        setError(errorMessage);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  const logout = useCallback(() => {
    authService.logout();
    navigate(ROUTES.LOGIN);
  }, [navigate]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    isLoading,
    error,
    login,
    logout,
    clearError,
  };
};